import { useCallback } from "react";
import { toast } from "sonner";
import {
	getSignedPutUrl,
	registerS3File,
	uploadFileToS3,
} from "../api/queries/files.queries";

export const useImageUpload = () => {
	const uploadImage = useCallback(async (file: File): Promise<string> => {
		try {
			if (!file.type.startsWith("image/")) {
				throw new Error("Le fichier doit être une image");
			}

			const maxSize = 5 * 1024 * 1024;
			if (file.size > maxSize) {
				throw new Error("L'image ne doit pas dépasser 5MB");
			}

			const signedPutData = await getSignedPutUrl({
				bucket: "public",
				contentType: file.type,
			});

			if (!signedPutData?.signedUrl || !signedPutData?.key) {
				throw new Error("Impossible d'obtenir l'URL d'upload");
			}

			await uploadFileToS3(signedPutData.signedUrl, file);

			const registeredFile = await registerS3File({
				bucket: "public",
				key: signedPutData.key,
				name: file.name,
				mimeType: file.type,
			});

			if (!registeredFile.url) {
				throw new Error("Impossible d'obtenir l'URL de l'image");
			}

			toast.success("Image uploadée avec succès");
			return registeredFile.url;
		} catch (error) {
			console.error("Erreur upload image:", error);
			const errorMessage =
				error instanceof Error
					? error.message
					: "Erreur lors de l'upload de l'image";
			toast.error(errorMessage);
			throw error;
		}
	}, []);

	return { uploadImage };
};
